<template>
    <div>
      <v-card-title class='pa-0 pl-3 pt-1'>
        <div class="pa-0 px-1 font-weight-bold pt-2 text-h6 primary--text">
          <v-icon color="primary">mdi-cash-multiple</v-icon>
          Financeiro
        </div>
      </v-card-title>
      <v-card-text class="px-0">
        <div class="ml-7">
          <div class="pa-0 px-1 font-weight-bold pt-2">Custo:</div>
          <div class="pa-0 px-3">{{formatMoney(event_info.value)}}</div> 
          <div class="pa-0 px-1 font-weight-bold pt-2" v-if="event_info.parcels.lenght > 0">Parcelas:</div>
          <div outlined v-for="(parcel, index) in event_info.parcels" :key="index">
            <div class="py-2 px-3"><strong>{{index+1}}ª Parcela</strong> - {{formatMoney(parcel.value)}} - Data: {{$dayjs(parcel.due_date).format('LL')}}</div> 
            <v-divider v-if="event_info.parcels[index+1] != null"></v-divider>
          </div>
        </div>
      </v-card-text>
    </div>
</template>
<script>
  export default {
    name: 'SummaryFinancial',
    props: {
      event_info: {
        type: Object,
      },
    },

    methods: {
      formatMoney(entry){
        return Number(entry/100).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
      },
    },
  }
</script>

<style lang="scss" scoped>

</style>